import React, { Component } from 'react';

import backIcon from "../assets/svg/back-icon.svg";
import arrowLeftIcon from "../assets/svg/arrow_left.svg";
import arrowRightIcon from "../assets/svg/arrow_right.svg";

import Isvg from "react-inlinesvg";
import { API_ENDPOINT } from '../constants';
import { Button } from 'reactstrap';
import { HTML_CHARACTERS } from '../../../server/dataManagment/htmlCharacters';

function parseSearch(search) {
    try {
        const queryString = search.startsWith('?') ? search.slice(1) : search;
        return queryString.split('&').reduce((acc, pair) => {
            const [key, value] = pair.split('=').map(decodeURIComponent);
            acc[key] = value;
            return acc;
        }, {});
    } catch (err) {
        console.error("Error parsing search string:", err);
        return {};
    }
}



/**
* GumletGateway component
* @author   Milan Stanojevic
*/
class GumletGateway extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    get = () => {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }
        const { gumletId, title, subtitle, web, conditionalLinkId, appAuthToken, returnUrl } = this.getParams();

        if (conditionalLinkId) {
            this.fetchConditionalLink(conditionalLinkId, appAuthToken);
        }
    }

    componentDidMount() {

        this.get();


    }
    fetchConditionalLink = (conditionalLinkId, appAuthToken) => {

        fetch(API_ENDPOINT + `/data/conditional-links/fetch-patient/${conditionalLinkId}`, {
            method: 'GET',
            headers: {
                'Authorization': appAuthToken ? `Bearer ${appAuthToken}` : typeof localStorage !== 'undefined' ? `Bearer ${localStorage?.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
        }).then(res => res.json()).then((result) => {
            if (result?.result?._id) {
                this.setState({ conditionalLink: result?.result }, () => {
                    this.checkNavigation(true)
                })
            }
        });
    }

    backAction = (returnUrl = null) => {
        try {
            const alias = typeof window !== 'undefined' && localStorage?.groupAlias ? localStorage?.groupAlias : null;
            if (returnUrl) {
                this.props[0].history.push(returnUrl);
                return;
            }
            if (alias) {
                this.props[0].history.push(`/${alias}`);
            } else {
                this.props[0].history.goBack();
            }


        } catch (error) {

        }

    }

    checkNavigation = (set = false) => {
        const { gumletId, title, subtitle, web, conditionalLinkId } = this.getParams();

        if (!this.state.conditionalLink || !gumletId || !subtitle) return;
        const conditionalLink = this.state.conditionalLink;
        const links = conditionalLink?.links?.length ? conditionalLink?.links?.filter(item => item?.link?.indexOf('gumlet.io') !== -1) : [];
        let currentIndex = links.findIndex(item => item?.link?.indexOf(gumletId) !== -1 && item?.buttonText === subtitle);

        let response = {
            prev: null,
            next: null,
            total: links?.length ?? 0,
        }
        if (currentIndex > 0) {
            let prev = links[currentIndex - 1];
            let linkSplit = prev?.link?.split('gumlet.io/');
            let paramsSplit = linkSplit[1].split('/');
            let _gumletId = paramsSplit?.[1]?.length === 24 ? paramsSplit[1] : null;

            response.prev = {
                gumletId: _gumletId,
                title: title,
                subtitle: prev?.buttonText,
                web: true,
                conditionalLinkId
            };
        }
        if (currentIndex < response.total - 1) {
            let next = links[currentIndex + 1];
            let linkSplit = next?.link?.split('gumlet.io/');
            let paramsSplit = linkSplit[1].split('/');
            let _gumletId = paramsSplit?.[1]?.length === 24 ? paramsSplit[1] : null;

            response.next = {
                gumletId: _gumletId,
                title: title,
                subtitle: next?.buttonText,
                web: true,
                conditionalLinkId
            };
        }

        if (set) {
            this.setState({ navigation: response });
        }

        return response;
    }
    goToLink = (data) => {
        if (!data) return;
        const { gumletId, subtitle, title, conditionalLinkId } = data;

        if (!gumletId || !subtitle || !title || !conditionalLinkId) return;
        if (gumletId?.length === 24) {
            this.props[0].history.push({
                pathname: `/gumlet-gateway`,
                state: {
                    gumletId: gumletId,
                    title: title,
                    subtitle: subtitle,
                    web: true,
                    conditionalLinkId
                }
            })
            this.get();
        }
    }
    getParams = () => {
        let response = {
            gumletId: null,
            title: null,
            subtitle: null,
            web: false,
            conditionalLinkId: null,
            appAuthToken: null,
            returnUrl: null
        }

        let data = this.props[0]?.location?.state;
        if (!data) {
            try {
                if (
                    this.props[0]?.location?.pathname?.includes?.('/gumlet-gateway/') &&
                    this.props[0]?.location?.search?.includes?.('is_app=true')
                ) {
                    const id = this.props[0]?.match?.params?.id;
                    if (id && id.length === 24) {
                        response.conditionalLinkId = id;
                        const searchParams = parseSearch(this.props[0]?.location?.search);
                        if (searchParams?.gumlet_id && searchParams?.gumlet_id?.length === 24) {
                            response.gumletId = searchParams?.gumlet_id;
                            if (searchParams?.title) response.title = searchParams?.title;
                            if (searchParams?.subtitle) response.subtitle = searchParams?.subtitle;
                            response.web = false;

                            if (searchParams?.at) response.appAuthToken = searchParams?.at;
                        }

                    } else if (!id || id.length !== 24) {
                        const searchParams = parseSearch(this.props[0]?.location?.search);
                        if (searchParams?.gumlet_id && searchParams?.gumlet_id?.length === 24) {
                            response.gumletId = searchParams?.gumlet_id;
                            if (searchParams?.title) response.title = searchParams?.title;
                            if (searchParams?.subtitle) response.subtitle = searchParams?.subtitle;
                            response.web = false;

                            if (searchParams?.at) response.appAuthToken = searchParams?.at;
                        }
                    }

                }
            } catch (err) { }

            return response;
        }
        response.gumletId = data?.gumletId ?? null;
        response.title = data?.title ?? null;
        response.subtitle = data?.subtitle ?? null;
        response.web = data?.web ?? false;
        response.conditionalLinkId = data?.conditionalLinkId ?? null;
        response.returnUrl = data?.returnUrl ?? null;
        return response;
    }

    replaceCharacters = (value) => {
        if (value) {
            for (let key in HTML_CHARACTERS) {
                value = value.replace(new RegExp(key, 'g'), HTML_CHARACTERS[key])
            }
        }
        return value;
    }

    render() {
        const { gumletId, title, subtitle, web, conditionalLinkId, returnUrl } = this.getParams();
        if (!gumletId) {
            return null;
        }
        const navigation = this.state.navigation ?? this.checkNavigation();
        return (
            <div>
                <div className='gumlet-title-section-wrap'>
                    {
                        web ?
                            <div className='back-icon-wrap' onClick={() => this.backAction(returnUrl)}><Isvg src={backIcon} />{'Back'.translate(this.props.lang)}</div>
                            :
                            null
                    }

                    {/* {web ? <div className='gumlet-title-wrap'>
                        <h5>{this.replaceCharacters(title)}</h5>
                        <p>{this.replaceCharacters(subtitle)}</p>
                    </div> : null} */}
                    {web ? <div className='gumlet-title-wrap'>
                        <h5>{title}</h5>
                        <p>{subtitle}</p>
                    </div> : null}
                </div>

                <div style={{ position: 'relative', aspectRatio: "16/9" }}>

                    <iframe
                        loading="lazy" title="Gumlet video player"
                        src={`https://play.gumlet.io/embed/${gumletId}?
preload=false&autoplay=false&loop=false&background=false&disable_p
layer_controls=false`}
                        style={{ border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
                        allow="accelerometer; gyroscope; autoplay; encrypted-media; 
picture-in-picture; fullscreen;">
                    </iframe>
                </div>

                {web ? <div className='gumlet-navigation-wrap'>
                    <Button disabled={!navigation?.prev || navigation?.total <= 1} color='primary' onClick={() => this.goToLink(navigation.prev)}><Isvg src={arrowLeftIcon} />{'Previous'.translate(this.props.lang)}</Button>
                    <Button disabled={!navigation?.next || navigation?.total <= 1} color='primary' onClick={() => this.goToLink(navigation.next)}>{'Next'.translate(this.props.lang)}<Isvg src={arrowRightIcon} /></Button>

                </div> : null}
            </div>
        );
    }
}

export default GumletGateway;